/* Product page: variant picking, price/stock updates, sticky ATC sync, size finder. */
(function () {
  'use strict';

  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  var dataEl = document.getElementById('ProductJson');
  if (!dataEl) return;

  var product = JSON.parse(dataEl.textContent);
  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

  var mainForm = root.querySelector('form[data-product-form][data-main-form]');
  var stickySelect = document.querySelector('#StickyAtc select[data-sticky-variant]');

  /* ----------------------------------------------------------------
     Media gallery (slideshow / thumbnail layouts)
  ---------------------------------------------------------------- */
  var galleryGoToSlide = null;

  (function initGallery() {
    var gallery = root.querySelector('[data-gallery]');
    if (!gallery || gallery.getAttribute('data-gallery') === 'stacked') return;

    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-gallery-slide]'));
    if (slides.length < 2) return;

    var gotoButtons = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-goto]'));

    function currentIndex() {
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
    }

    function setActive(index) {
      gotoButtons.forEach(function (button) {
        button.classList.toggle('is-active', parseInt(button.getAttribute('data-gallery-goto'), 10) === index);
      });
    }

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index > slides.length - 1) index = 0;
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      setActive(index);
    }

    galleryGoToSlide = function (mediaEl) {
      var index = slides.indexOf(mediaEl);
      if (index > -1) goTo(index);
    };

    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });

    gotoButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        goTo(parseInt(button.getAttribute('data-gallery-goto'), 10));
      });
    });

    var scrollRaf = null;
    track.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = null;
        setActive(currentIndex());
      });
    }, { passive: true });
  })();

  function formatMoney(cents) {
    var placeholder = (moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/) || [null, 'amount'])[1];
    var delimited = function (decimals, thousands, decimal) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    var value;
    switch (placeholder) {
      case 'amount_no_decimals': value = delimited(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimited(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimited(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimited(2, "'", '.'); break;
      default: value = delimited(2, ',', '.');
    }
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function selectedOptions() {
    var options = [];
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var checked = group.querySelector('input:checked');
      if (checked) options[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
    });
    return options;
  }

  function findVariant(options) {
    return product.variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return options[index] === value;
      });
    });
  }

  function updateAvailabilityStates(options) {
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      group.querySelectorAll('.option-pill').forEach(function (pill) {
        var input = pill.querySelector('input');
        var candidate = options.slice();
        candidate[index] = input.value;
        var variant = findVariant(candidate);
        pill.classList.toggle('is-unavailable', !variant || !variant.available);
      });
    });
  }

  function updateStockNote(variant) {
    var note = root.querySelector('[data-stock-note]');
    if (!note) return;
    var threshold = parseInt(note.getAttribute('data-low-threshold'), 10) || 0;
    var label = note.querySelector('[data-stock-label]');
    note.classList.remove('stock-note--low', 'stock-note--out');
    if (!variant || !variant.available) {
      note.classList.add('stock-note--out');
      label.textContent = note.getAttribute('data-text-out');
    } else if (
      threshold > 0 &&
      variant.inventory_management &&
      typeof variant.inventory_quantity === 'number' &&
      variant.inventory_quantity > 0 &&
      variant.inventory_quantity <= threshold
    ) {
      note.classList.add('stock-note--low');
      label.textContent = note.getAttribute('data-text-low').replace('[count]', variant.inventory_quantity);
    } else {
      label.textContent = note.getAttribute('data-text-in');
    }
  }

  function updatePrice(variant) {
    root.querySelectorAll('[data-price-wrapper]').forEach(function (wrapper) {
      var priceEl = wrapper.querySelector('[data-price]');
      var compareEl = wrapper.querySelector('[data-compare-price]');
      if (!variant) return;
      priceEl.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceEl.classList.toggle('price__sale', !!onSale);
      if (compareEl) {
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price);
      }
    });
  }

  function updateButtons(variant) {
    document.querySelectorAll('form[data-product-form] [type="submit"]').forEach(function (button) {
      var label = button.querySelector('.btn-label');
      if (!variant) {
        button.disabled = true;
        if (label) label.textContent = button.getAttribute('data-text-unavailable');
      } else if (!variant.available) {
        button.disabled = true;
        if (label) label.textContent = button.getAttribute('data-text-soldout');
      } else {
        button.disabled = false;
        if (label) label.textContent = button.getAttribute('data-text-add');
      }
    });
  }

  function updateForms(variant) {
    if (!variant) return;
    document.querySelectorAll('form[data-product-form] [name="id"]').forEach(function (input) {
      input.value = variant.id;
    });
    if (stickySelect && stickySelect.value !== String(variant.id)) {
      stickySelect.value = String(variant.id);
    }
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      var valueEl = group.querySelector('.option-group__value');
      if (valueEl) valueEl.textContent = variant.options[index];
    });
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function onVariantChange() {
    var options = selectedOptions();
    var variant = findVariant(options);
    updatePrice(variant);
    updateButtons(variant);
    updateStockNote(variant);
    updateForms(variant);
    updateAvailabilityStates(options);
    if (variant && variant.featured_media) {
      var media = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (media) {
        if (galleryGoToSlide) galleryGoToSlide(media);
        else media.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  root.addEventListener('change', function (event) {
    if (event.target.closest('[data-option-index]')) onVariantChange();
  });

  if (stickySelect) {
    stickySelect.addEventListener('change', function () {
      var variant = product.variants.find(function (v) { return String(v.id) === stickySelect.value; });
      if (!variant) return;
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        var input = group.querySelector('input[value="' + CSS.escape(variant.options[index]) + '"]');
        if (input) input.checked = true;
      });
      onVariantChange();
    });
  }

  onVariantChange();

  if (window.SizeFinder) {
    window.SizeFinder.setContextFromProduct(product);
  }

  /* Description line clamp. The Read more button renders by default and is
     hidden only when the text fits within the limit — checked on load and
     again whenever the theme editor re-renders the section. Click handling
     is delegated so it survives those re-renders. */
  function refreshDescToggles() {
    document.querySelectorAll('[data-desc-clamp]').forEach(function (text) {
      var wrap = text.closest('.product__description');
      var toggle = wrap && wrap.querySelector('[data-desc-toggle]');
      if (!toggle) return;
      if (text.classList.contains('is-clamped')) {
        toggle.hidden = text.scrollHeight <= text.clientHeight + 1;
      }
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-desc-toggle]');
    if (!toggle) return;
    var wrap = toggle.closest('.product__description');
    var text = wrap && wrap.querySelector('[data-desc-clamp]');
    if (!text) return;
    var clamped = text.classList.toggle('is-clamped');
    toggle.textContent = toggle.getAttribute(clamped ? 'data-text-more' : 'data-text-less');
  });

  refreshDescToggles();
  document.addEventListener('shopify:section:load', refreshDescToggles);

  /* Apply the size finder recommendation (modal logic lives in size-finder-ui.js) */
  document.addEventListener('sizefinder:result', function (event) {
    var pill = root.querySelector('[data-option-index] input[value="' + CSS.escape(event.detail.size) + '"]');
    if (pill) {
      pill.checked = true;
      onVariantChange();
    }
  });
})();
